import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy } from '@angular/core'; // Agrega OnDestroy
import { Router } from '@angular/router';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { OndemandSocketService } from 'src/app/services/ondemand-socket.service';

@Component({
  selector: 'app-reserva',
  templateUrl: './reserva.component.html',
  styleUrls: ['../../../assets/css/styles.css', './reserva.component.css']
})
export class ReservaComponent implements OnInit, OnDestroy { // Implementa OnDestroy

  public usuario: any;
  private intervalId: any; // Guarda el ID del intervalo para limpiarlo después

    public pageInfo: any = {};


  tiempoEspera: any = {
    data: {
      horaPrimerPaciente: null,
      minutes: null,
      nroMedicos: null,
      posicion: null,
      tiempoEspera: null,
      tiempoEsperaTotal: null,
      totalPacientes: null
    }
  };

  constructor(
    private router: Router,
    public _usuarioService: UsuarioService,
    private scheduleService: ScheduleService,
    private cdRef: ChangeDetectorRef,
    private ondemandSocketService: OndemandSocketService,
    
  ) {}

  ngOnInit(): void {
    this.usuario = new EncriptacionService().getUserInfo();
    // console.log(this.usuario);
    this.pageInfo = new EncriptacionService().getPageInfo();

    if (this.usuario.typ_id == 2) {
      this.postListUsersWaitList();
      this.ondemandSocketService.onDoctorDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorNoDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorFinalizaConsulta().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onActualizaFila().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
    }
  }

  postListUsersWaitList() {
    this.scheduleService.postListUsersWaitList(this.usuario._id, this.usuario.typ_id)
      .then((response: any) => {
        // console.log('Respuesta del servicio:', response);
        this.tiempoEspera = response;

        this.cdRef.detectChanges();
      })
      .catch((error: any) => {
        console.error('Error al obtener la lista de espera:', error);
      });
  }

  redondearTiempo(tiempo: number): number {
    return Math.min(Math.max(Math.round(tiempo), 5), 60); // mínimo 5, máximo 60
  }

  reservaHora() {
    var url = "reserva-hora/";
    this.router.navigate([url]);
  }

  reservaOnDemand() {
    var url = "reserva-on-demand/";
    this.router.navigate([url]);
  }
  redirectToFilaEspera(){
    let url = `fila-ondemand/${this.tiempoEspera.consulta.tel_doc_od_id}/${this.tiempoEspera.consulta.tel_doc_od_id}`;
    this.router.navigate([url]);

  }

  redirectToSalaEspera(){
    let url = `salaespera/${this.tiempoEspera.consulta.tel_doc_app_boo_id}/${this.tiempoEspera.consulta.tel_doc_app_boo_id}/${this.tiempoEspera.consulta.med_con_id}`;
    this.router.navigate([url]);

  }

  redirectToMesaAyuda() {
    var url = "mesaAyuda/";
    this.router.navigate([url]);
  }

  ngOnDestroy(): void {
    // Limpia el intervalo cuando se destruya el componente
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
